import { Action, creator } from 'src/config/rootAction';

import { FetchedProgramProgress, UserProgramWeek } from '../models/programs';

export const FETCH_PROGRAMS_PROGRESS_SUCCEEDED = 'FETCH_PROGRAMS_PROGRESS_SUCCEEDED';
export type FetchProgramsProgressSuccessAction = Action<
    typeof FETCH_PROGRAMS_PROGRESS_SUCCEEDED,
    FetchedProgramProgress[]
>;
export const fetchProgramsProgressSuccess = creator<FetchProgramsProgressSuccessAction>(
    FETCH_PROGRAMS_PROGRESS_SUCCEEDED,
);

export const FETCH_PROGRAMS_PROGRESS_FAILED = 'FETCH_PROGRAMS_PROGRESS_FAILED';
export type FetchProgramsProgressFailAction = Action<typeof FETCH_PROGRAMS_PROGRESS_FAILED>;
export const fetchProgramsProgressFail = creator<FetchProgramsProgressFailAction>(
    FETCH_PROGRAMS_PROGRESS_FAILED,
);

export const UPDATE_PROGRAM_WEEK_REQUESTED = 'UPDATE_PROGRAM_WEEK_REQUESTED';
export type UpdateProgramWeekRequestAction = Action<
    typeof UPDATE_PROGRAM_WEEK_REQUESTED,
    UserProgramWeek
>;
export const updateProgramWeek = creator<UpdateProgramWeekRequestAction>(
    UPDATE_PROGRAM_WEEK_REQUESTED,
);

export const UPDATE_PROGRAM_WEEK_SUCCEEDED = 'UPDATE_PROGRAM_WEEK_SUCCEEDED';
export type UpdateProgramWeekSuccessAction = Action<
    typeof UPDATE_PROGRAM_WEEK_SUCCEEDED,
    UserProgramWeek
>;
export const updateProgramWeekSuccess = creator<UpdateProgramWeekSuccessAction>(
    UPDATE_PROGRAM_WEEK_SUCCEEDED,
);

export const UPDATE_PROGRAM_WEEK_FAILED = 'UPDATE_PROGRAM_WEEK_FAILED';
export type UpdateProgramWeekFailAction = Action<typeof UPDATE_PROGRAM_WEEK_FAILED>;
export const updateProgramWeekFail = creator<UpdateProgramWeekFailAction>(
    UPDATE_PROGRAM_WEEK_FAILED,
);

export const PROGRAM_WEEK_FINISHED = 'PROGRAM_WEEK_FINISHED';
export type ProgramWeekFinishedAction = Action<typeof PROGRAM_WEEK_FINISHED>;
export const programWeekFinished = creator<ProgramWeekFinishedAction>(PROGRAM_WEEK_FINISHED);

export type ProgramsAction =
    | FetchProgramsProgressSuccessAction
    | FetchProgramsProgressFailAction
    | UpdateProgramWeekRequestAction
    | UpdateProgramWeekSuccessAction
    | UpdateProgramWeekFailAction
    | ProgramWeekFinishedAction;
